var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item.loading ? _c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
    click: function click() {
      return _vm.$emit('click');
    }
  } : {}), [_vm._t("icon"), _c('v-list-item-content', [_c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.title) + " ")]), _vm.item.numberplate ? _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.item.numberplate) + " ")]) : _vm._e()], 1), !_vm.small ? _c('v-list-item-subtitle', [_vm.item.seller ? _c('span', [_vm._v(_vm._s(_vm.item.seller.name))]) : _vm._e()]) : _vm._e(), !_vm.small && (_vm.item.start || _vm.item.end) ? _c('v-list-item-subtitle', [_vm.item.start ? _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.item.start) + " ")]) : _vm._e(), _vm.item.end ? _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.item.end) + " ")]) : _vm._e()], 1) : _vm._e()], 1)], 2) : _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-three-line"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }